<template>
    <v-row class="">
        <v-col cols="12" md="4" class="px-0">
            <v-sheet class="pa-2 mx-1" elevation="1">
                <span class="font-weight-bold">Name: </span><span class="float-right">{{ selectedUserPayrollReport.Name }}</span><br>
                <span class="font-weight-bold">Program: </span>
                <span class="float-right" v-if="selectedUserPayrollReport.Program.length < 4">{{ selectedUserPayrollReport.Program.toString() }}</span>
                <span class="" v-else><br>{{ selectedUserPayrollReport.Program.toString() }}</span><br>
                <span class="font-weight-bold">State: </span><span class="float-right">{{ selectedUserPayrollReport.State }}</span><br>
                <span class="font-weight-bold">Position: </span><span class="float-right">{{ selectedUserPayrollReport.Role }}</span><br>
                <span class="font-weight-bold">Rate: </span><span class="float-right">$ {{ selectedUserPayrollReport.Rate }}</span><br>
            </v-sheet>
        </v-col>
        <v-col cols="12" md="8">
            <v-sheet>
                <v-tabs
                    v-model="tab"
                    align-with-title
                    grow
                >
                    <v-tabs-slider color=""></v-tabs-slider>

                    <v-tab
                        class="ms-0"
                        v-for="item in items"
                        :key="item"
                    >
                        {{ item }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab" class="mt-3">
                    <v-tab-item>
                        <v-expansion-panels
                            v-model="selectedCompPanel"
                        >
                            <UserPayrollReportItems
                                v-for="(compensation, index) in compensations"
                                :key="index"
                                :tab="tab"
                                :isEdit="compensation.isEdit"
                                :tabItems="compensation"
                                :index="index"
                                :tabType="'comp'"
                            ></UserPayrollReportItems>
                        </v-expansion-panels>

                        <v-divider class="my-3"></v-divider>

                        <span>Total Amount: </span>
                        <span class="float-right">$ {{ calculateTotalCompensations() }}</span>
                    </v-tab-item>
                    <v-tab-item>
                        <v-expansion-panels
                            v-model="selectedDeductPanel"
                        >
                            <UserPayrollReportItems
                                v-for="(deduction, index) in deductions"
                                :key="index"
                                :tab="tab"
                                :isEdit="deduction.isEdit"
                                :tabItems="deduction"
                                :index="index"
                                :tabType="'deduct'"
                            ></UserPayrollReportItems>
                        </v-expansion-panels>

                        <v-divider class="my-3"></v-divider>

                        <span>Total Amount: </span>
                        <span class="float-right">$ {{ calculateTotalDeductions() }}</span>
                    </v-tab-item>
                </v-tabs-items> 
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
    import axios from 'axios';
    // import moment from "moment";
    import {mapState, mapMutations} from "vuex";

    import UserPayrollReportItems from "../UserPayrollReportsItems.vue"

    const url = require("../../../../client_config/config").url;
    export default {
        components: {UserPayrollReportItems},

        props: {
            // selectedUserPayrollReport: Object
        },

        data () {
            return {
                tab: null,
                items: [
                    "Compensations", "Deductions",
                ],
                
                isEdit: false,
                isSavingEditLoading: false,

                compensations: [
                    {item: "Raise", variable: 0, itemValue: null, isEdit: false, isSavingEditLoading: false, isEditable: true},
                    {item: "Bonus", variable: 0, itemValue: null, isEdit: false, isSavingEditLoading: false, isEditable: true},
                    {item: "Reimbursements", variable: 0, itemValue: null, isEdit: false, isSavingEditLoading: false, isEditable: true},
                    {item: "Health Care", variable: 0, itemValue: null, isEdit: false, isSavingEditLoading: false, isEditable: true, tba: false,
                        typesOfItem: ["Health Care 1", "Health Care 2", "Health Care 3"]
                    },
                    {item: "Incentives", variable: 0, itemValue: null, isEdit: false, isSavingEditLoading: false, isEditable: true, tba: false,
                        typesOfItem: ["Incentives 1", "Incentives 2", "Incentives 3"]
                    },
                ],
                deductions: [
                    {item: "Garnishments", variable: 0, itemValue: null, isEdit: false, isSavingEditLoading: false, isEditable: true},
                    {item: "Writ", variable: 0, itemValue: null, isEdit: false, isSavingEditLoading: false, tba: true, isEditable: false},
                    {item: "Child Support", variable: 0, itemValue: null, isEdit: false, isSavingEditLoading: false, tba: true, isEditable: false},
                    {item: "Loan", variable: 0, itemValue: null, isEdit: false, isSavingEditLoading: false, tba: true, isEditable: false},
                ],

                openExpansionContent: false,
                // selectedPanel: []
            }
        },

        watch: {
            tab () {
                this.isEdit = false
            },
        },

        created () {
            this.getUserReportsValue();
        },

        computed: {
            ...mapState({
                selectedUserPayrollReport: state => state.payrollReportsHistories.selectedUserPayrollReport,
                selectedCompPanel: state => state.payrollReportsHistories.selectedCompPanel,
                selectedDeductPanel: state => state.payrollReportsHistories.selectedDeductPanel,
            })
        },

        methods: {
            ...mapMutations({
                setContentTab: "payrollReportsHistories/setContentTab",
                setHistoryTab: "payrollReportsHistories/setHistoryTab",
                // setSelectedPanel: "payrollReportsHistories/setSelectedPanel"
            }),

            getUserReportsValue () {
                // const payrollReports = this.compensations.concat(this.deductions)
                this.compensations.map(async payrollReport => {
                    switch (payrollReport.item) {
                        case "Raise":
                            payrollReport.itemValue = await axios.get(`${url}/raises/getStaffLatestRaise/${this.selectedUserPayrollReport.Email}/${this.selectedUserPayrollReport._id}`).then(res => res.data != null ? res.data.Raise : 0);
                            break;
                        case "Bonus":
                            payrollReport.itemValue = await axios.get(`${url}/bonuses/getStaffLatestBonus/${this.selectedUserPayrollReport._id}`).then(res => res.data != null ? res.data.Bonus : 0);
                            break;
                        case "Reimbursements":
                            payrollReport.itemValue = await axios.get(`${url}/reimbursements/getStaffLatestReimbursement/${this.selectedUserPayrollReport._id}`).then(res => res.data != null ? res.data.Amount : 0);
                            break;
                        case "Health Care":
                            payrollReport.itemValue = await axios.get(`${url}/healthcare/getStaffLatestHealthCare/${this.selectedUserPayrollReport._id}`).then(res => res.data != null ? res.data.Amount : 0);
                            break;
                        case "Incentives":
                            payrollReport.itemValue = await axios.get(`${url}/incentives/getStaffLatestIncentive/${this.selectedUserPayrollReport._id}`).then(res => res.data != null ? res.data.Amount : 0);
                            break;
                        default:
                            break;
                    }
                })

                this.deductions.map(async payrollReport => {
                    switch (payrollReport.item) {
                        case "Garnishments":
                            payrollReport.itemValue = await axios.get(`${url}/garnishments/getStaffLatestGarnishment/${this.selectedUserPayrollReport._id}`).then(res => res.data != null ? res.data.Amount : 0);
                            break;
                        case "Writ":
                            if (this.selectedUserPayrollReport.Writ) payrollReport.itemValue = parseFloat(this.selectedUserPayrollReport.Writ);
                            break;
                        case "Child Support":
                            if (this.selectedUserPayrollReport.ChildSupport) payrollReport.itemValue = parseFloat(this.selectedUserPayrollReport.ChildSupport);
                            break;
                        case "Loan":
                            if (this.selectedUserPayrollReport.Loan) payrollReport.itemValue = parseFloat(this.selectedUserPayrollReport.Loan);
                            break;  
                        default:
                            break;
                    }
                })
            },

            preventNonNumericInput (e) {
                const keysAllowed= ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
                const keyPressed= e.key;
                
                if (!keysAllowed.includes(keyPressed)) {
                    e.preventDefault()
                }
            },

            calculateTotalCompensations () {
                let totalCompensations = 0;

                this.compensations.forEach(comp => {
                    comp.itemValue = parseFloat(comp.itemValue || 0);
                    totalCompensations += isNaN(comp.itemValue) ? 0 : comp.itemValue;
                })
                return totalCompensations
            },

            calculateTotalDeductions () {
                let totalDeductions = 0;

                this.deductions.forEach(deduct => {
                    deduct.itemValue = parseFloat(deduct.itemValue || 0);
                    totalDeductions += isNaN(deduct.itemValue) ? 0 : deduct.itemValue;
                })

                return totalDeductions;
            },

            viewHistory (historyTab) {
                this.setContentTab('viewHistoryTab')
                this.setHistoryTab(historyTab)
            },

            // panel (index) {
            //     console.log(index);
            //     if (this.selectedCompPanel.length == 0 && index == 0) {
            //         this.selectedCompPanel = 0;
            //     } else {
            //         this.selectedCompPanel = index == this.selectedCompPanel ? [] : index
            //     }
            // }
        }
    }
</script>